import { PICSuggestion, PICSelector } from '../Internals';
export class PICValidate {
    constructor(iRules, iField, iPreventSubmit = false, iValidateEvent = 'change') {
        this.rules = iRules;
        this.field = iField;
        this.preventSubmit = iPreventSubmit;
        this.validateEvent = iValidateEvent;
    }
    addByProg(iRule) {
        switch (iRule.ruleType) {
            case 'minlength': {
                this.rules.push(new PICMinLength(this.field, iRule));
                break;
            }
            case 'maxlength': {
                this.rules.push(new PICMaxLength(this.field, iRule));
                break;
            }
            case 'starterror': {
                this.rules.push(new PICStartError(this.field, iRule));
                break;
            }
            case 'minvalue': {
                this.rules.push(new PICMinValue(this.field, iRule));
                break;
            }
            case 'maxvalue': {
                this.rules.push(new PICMaxValue(this.field, iRule));
                break;
            }
            case 'mindate': {
                this.rules.push(new PICMinDate(this.field, iRule));
                break;
            }
            case 'maxdate': {
                this.rules.push(new PICMaxDate(this.field, iRule));
                break;
            }
            case 'required': {
                this.rules.push(new PICRequired(this.field, iRule));
                this.field.required_ = true;
                this.preventSubmit = true;
                break;
            }
            case 'pattern': {
                this.rules.push(new PICPattern(this.field, iRule));
                break;
            }
            case 'validatedate': {
                this.rules.push(new PICDateValidate(this.field, iRule));
                break;
            }
            case 'dateediting': {
                this.rules.push(new PICDateEditing(this.field, iRule));
                break;
            }
            case 'isnumeric': {
                this.rules.push(new PICIsNumeric(this.field, iRule));
                break;
            }
            case 'isint': {
                this.rules.push(new PICIsInteger(this.field, iRule));
                break;
            }
            case 'contid': {
                this.rules.push(new PICPatternExt(this.field, { ruleType: 'contid', value: String.raw `([A-Z]|[a-z]){3}(U|u|J|j|Z|z)`, errorMessage: 'Container ID must start with XXX(J/U/Z)' }, 4));
                this.rules.push(new PICMaxLength(this.field, { ruleType: 'contid', value: 13, errorMessage: 'Container ID can not be more than 13 characters.' }));
                this.rules.push(new PICValidateContainerDigits(this.field, { ruleType: 'contid', value: true, errorMessage: 'Too many digits in container ID' }));
                this.rules.push(new PICValidateCheckDigit(this.field, { ruleType: 'contid', value: iRule.value, errorMessage: iRule.errorMessage }));
                break;
            }
            case 'isvalidsuggestion': {
                this.rules.push(new PICIsValidSuggestion(this.field, iRule));
                /*if(this.field instanceof PICSelector && this.field.selectType_ === 'suggestion')
                else
                    throw new Error('Rule can only be applied to PICSelector of type suggestion');*/
            }
            default: {
                throw new Error('Invalid validation: ' + iRule);
            }
        }
    }
    add(iRule) {
        if (iRule) {
            if (iRule instanceof PICRule) {
                this.rules.push(iRule);
            }
        }
        else
            throw new Error('iRule is undefined.');
    }
    remove(iRule) {
        if (iRule) {
            if (iRule instanceof PICRule) {
                let index = this.rules.indexOf(iRule);
                if (index > -1) {
                    this.rules.splice(index, 1);
                }
            }
        }
    }
    /** Only deletes start errors, for now */
    delete(iRule) {
        if (iRule.ruleType === 'starterror') {
            let found = this.rules.find(rule => rule instanceof PICStartError);
            if (found)
                this.rules.splice(this.rules.indexOf(found), 1);
        }
        else
            throw new Error('iRule is undefined.');
    }
    clearRules() {
        this.rules = [];
    }
    hasRules() {
        return this.rules.length > 0;
    }
    isInvalid(iString, preventRec) {
        let res = [];
        this.rules.forEach(rule => {
            let tmp = rule.test(iString, preventRec);
            if (!tmp.pass)
                res.push(tmp);
        });
        if (res.length > 0)
            return res;
        return false;
    }
}
export class PICRule {
    constructor(iFieldRef, iRule) {
        this.thisFieldRef = iFieldRef;
        if (iRule.value)
            this.condition = iRule.value;
        if (iRule.errorMessage)
            this.failMsg = iRule.errorMessage;
        if (iRule.fieldID)
            this.conditionField = iRule.fieldID;
    }
    getConditionValue(iType, iStopProp) {
        let retVal;
        if (this.condition)
            retVal = this.condition;
        else {
            this.thatFieldRef = this.thisFieldRef.getRootNode().querySelector('#' + this.conditionField);
            if (this.thatFieldRef) {
                retVal = this.thatFieldRef.submitValue;
                if (!iStopProp) {
                    this.thatFieldRef.validate(true);
                }
            }
        }
        switch (iType) {
            case 'number':
                return parseFloat(retVal);
                break;
            case 'string':
                return retVal;
                break;
            case 'Date':
                return retVal;
                break;
            case 'boolean':
                return retVal === 'true';
                break;
            default:
                return '';
                break;
        }
    }
}
export class PICMinLength extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This text is too short';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (iValue) {
            const conditionValue = this.getConditionValue('number', iStopProp);
            if (typeof conditionValue === 'number' && iValue.length >= conditionValue) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: false, failMessage: this.failMsg };
    }
}
export class PICMaxLength extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This text is too long';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (iValue) {
            const conditionValue = this.getConditionValue('number', iStopProp);
            if (typeof conditionValue === 'number' && iValue.length <= conditionValue) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
export class PICMinValue extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'Value too low';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        iValue = parseInt(iValue);
        if (iValue) {
            const conditionValue = this.getConditionValue('number', iStopProp);
            if (typeof conditionValue === 'number' && iValue >= conditionValue) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
export class PICMaxValue extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'Value too high';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (iValue) {
            const conditionValue = this.getConditionValue('number', iStopProp);
            if (typeof conditionValue === 'number' && iValue <= conditionValue) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
export class PICMinDate extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This Date is too early';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (iValue) {
            if (typeof iValue === 'string') {
                if (iValue === 'null')
                    return { pass: true, failMessage: this.failMsg };
            }
            if (iValue >= this.getConditionValue('Date', iStopProp)) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
export class PICMaxDate extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This Date is past the limit';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (iValue) {
            if (typeof iValue === 'string') {
                if (iValue === 'null')
                    return { pass: true, failMessage: this.failMsg };
            }
            if (iValue <= this.getConditionValue('Date', iStopProp)) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
export class PICRequired extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This field is required';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (this.thisFieldRef instanceof PICSelector || this.thisFieldRef instanceof PICSuggestion) {
            if (this.thisFieldRef.eType == 'old') { // w2.5
                if (this.thisFieldRef.optionContainer.isValInOptions(this.thisFieldRef.submitValue) !== 'not') {
                    return { pass: true, failMessage: this.failMsg };
                }
            }
            else if (this.thisFieldRef.selectedOption) { //w3
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        else {
            if (iValue.length > 0) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
    }
}
export class PICCustomError extends PICRule {
    constructor(iFieldRef, iRule) {
        super(iFieldRef, iRule);
    }
    setValue(value) {
        this.condition = value;
    }
    test(iValue, iStopProp) {
        if (this.getConditionValue('string', iStopProp)) {
            return { pass: true, failMessage: this.failMsg };
        }
        return { pass: false, failMessage: this.failMsg };
    }
}
export class PICStartError extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This is a start error';
        super(iFieldRef, iRule);
        console.log(iRule, this.failMsg);
    }
    test(iValue, iStopProp) {
        return { pass: false, failMessage: this.failMsg };
    }
}
export class PICPattern extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This field must match the pattern';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (this.getConditionValue('string', iStopProp)) {
            let res = new RegExp(this.condition).exec(iValue);
            if (res) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
export class PICIsNumeric extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'Must be a number';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (this.getConditionValue('boolean', iStopProp)) {
            let res = isNum(iValue);
            if (res) {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
        function isNum(num) {
            if (typeof num === 'number') {
                return num - num === 0;
            }
            if (typeof num === 'string' && num.trim() !== '') {
                return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
            }
            return false;
        }
        ;
    }
}
export class PICIsInteger extends PICIsNumeric {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'Must be a whole number';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (this.getConditionValue('boolean', iStopProp)) {
            let superRes = super.test(iValue, iStopProp);
            if (superRes.pass) {
                if (Number.isInteger(Number(iValue))) {
                    return { pass: true, failMessage: this.failMsg };
                }
                else {
                    return { pass: false, failMessage: this.failMsg };
                }
            }
            else {
                return superRes;
            }
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
class PICPatternExt extends PICRule {
    constructor(iFieldRef, iRule, iMin) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'This field must match the pattern';
        super(iFieldRef, iRule);
        this.min = iMin;
    }
    test(iValue, iStopProp) {
        if (this.condition) {
            if (iValue.length >= this.min) {
                let res = new RegExp(this.getConditionValue('string', iStopProp)).exec(iValue);
                if (res) {
                    return { pass: true, failMessage: this.failMsg };
                }
                return { pass: false, failMessage: this.failMsg };
            }
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
export class PICDateValidate extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'Invalid Date';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (this.getConditionValue('boolean', iStopProp)) {
            if (parse(iValue) != 'invalid date') {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
        function parse(str) {
            if (str === 'null')
                return 'invalid date';
            if (str.includes('–'))
                return 'invalid date';
            let y = parseInt(str.substr(0, 4)), m = parseInt(str.substr(4, 2)) - 1, d = parseInt(str.substr(6, 2));
            var D = new Date(y, m, d);
            return ((D.getFullYear() == y && D.getMonth() == m && D.getDate() == d) && str.length <= 8) ? D : 'invalid date';
        }
    }
}
export class PICDateEditing extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'Invalid Date';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (this.getConditionValue('boolean', iStopProp)) {
            if (!iValue.includes('–') && iValue != 'null') {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: true, failMessage: this.failMsg };
    }
}
class PICValidateContainerDigits extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = '';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        var _a;
        if (iValue.length >= 10) {
            let tmp = (_a = iValue.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.join('');
            if (tmp) {
                if (tmp.length > 7)
                    return { pass: false, failMessage: 'Too many digits' };
            }
        }
        return { pass: true, failMessage: '' };
    }
}
class PICValidateCheckDigit extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = '';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        let trimVal = iValue.replace('-', '').replace('?', '').replace(' ', '');
        if (trimVal.length == 11) {
            let checkDig = getCheckDigit(trimVal);
            if (checkDig != parseInt(trimVal.charAt(10))) {
                if (!isNaN(checkDig))
                    return { pass: false, failMessage: 'Check digit should be: ' + checkDig };
                return { pass: false, failMessage: 'Not a valid container format' };
            }
        }
        return { pass: true, failMessage: '' };
        function getCheckDigit(iStr) {
            // calc1
            let arr1 = toNumeric(iStr.toUpperCase());
            // calc2
            let arr2 = toPower(arr1);
            // calc3
            //1
            let sum1 = sum(arr2);
            //2 & 3
            let div1 = Math.floor(sum1 / 11);
            //4
            div1 = div1 * 11;
            //5 
            let checkdigit = sum1 - div1;
            if (checkdigit == 10)
                checkdigit = 0;
            return checkdigit;
            function toNumeric(iVal) {
                let chrVals = { 'A': 10, 'B': 12, 'C': 13, 'D': 14, 'E': 15, 'F': 16, 'G': 17, 'H': 18, 'I': 19, 'J': 20, 'K': 21, 'L': 23, 'M': 24, 'N': 25, 'O': 26, 'P': 27, 'Q': 28, 'R': 29, 'S': 30, 'T': 31, 'U': 32, 'V': 34, 'W': 35, 'X': 36, 'Y': 37, 'Z': 38 };
                let res = [];
                for (var i = 0; i < 10; i++) {
                    if (i <= 3) {
                        res.push(chrVals[iVal.charAt(i)]);
                    }
                    else {
                        res.push(parseInt(iVal.charAt(i)));
                    }
                }
                return res;
            }
            function toPower(iArr) {
                let res = [];
                for (let i = 0; i < iArr.length; i++) {
                    res.push(iArr[i] * Math.pow(2, i));
                }
                return res;
            }
            function sum(iArr) {
                let res = 0;
                for (let i = 0; i < iArr.length; i++) {
                    res += iArr[i];
                }
                return res;
            }
        }
    }
}
export class PICIsValidSuggestion extends PICRule {
    constructor(iFieldRef, iRule) {
        if (!iRule.errorMessage)
            iRule.errorMessage = 'Please choose a valid option';
        super(iFieldRef, iRule);
    }
    test(iValue, iStopProp) {
        if (this.thisFieldRef.selectedOption) {
            return { pass: true, failMessage: this.failMsg };
        }
        else if (this.thisFieldRef.selKey) {
            if (this.thisFieldRef.optionContainer.isValInOptions(this.thisFieldRef.selKey) == 'key') {
                return { pass: true, failMessage: this.failMsg };
            }
            return { pass: false, failMessage: this.failMsg };
        }
        return { pass: false, failMessage: this.failMsg };
    }
}
//# sourceMappingURL=PICValidate.js.map